import type { RouteRecordRaw } from "vue-router";
import { APP_CHAT_CUSTOMER_ROUTES } from "@/Generated/Routes/paths";

import Agreements from "./Agreements";
import Breaks from "./Breaks";
import Questionnaires from "./Questionnaires";
import Subscription from "./Subscription";
import ClinicalHistory from "./ClinicalHistory";
import Schedule from "./Schedule";

import { buildBeforeEnterChain, chatCustomerGuard } from "@/Router/guards";

const CustomerRoutes: RouteRecordRaw[] = [
  {
    path: APP_CHAT_CUSTOMER_ROUTES.root.path,
    meta: {
      sidebar: true,
    },
    beforeEnter: buildBeforeEnterChain(chatCustomerGuard),
    children: [
      {
        ...APP_CHAT_CUSTOMER_ROUTES.root,
        component: () => import("@/Views/chat/customer/views/PatientProfile.vue"),
      },
      {
        ...APP_CHAT_CUSTOMER_ROUTES.patientDetail.root,
        component: () => import("@/Views/chat/customer/views/PatientDetail/PatientDetail.vue"),
        meta: {
          i18nTitle: "user.settings.customer.patient_details",
        },
      },
      {
        ...APP_CHAT_CUSTOMER_ROUTES.subscription.discharge.root,
        component: () => import("@/Views/chat/customer/views/Discharge/index.vue"),
        meta: {
          i18nTitle: "user.settings.customer.patient_discharge",
        },
      },
      {
        ...APP_CHAT_CUSTOMER_ROUTES.activity.root,
        component: () => import("@/Views/activityCenter/index.vue"),
        meta: {
          noHeader: true,
        },
      },
      ...Agreements,
      ...Breaks,
      ...ClinicalHistory,
      ...Questionnaires,
      ...Subscription,
      ...Schedule,
    ],
  },
];

export default CustomerRoutes;
